import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsOfServicePage = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Trusted Trademark Filer</title>
        <meta name="description" content="Review the Terms of Service for Trusted Trademark Filer. Understand your rights and responsibilities when using our trademark registration and intellectual property services." />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="py-20">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-5xl font-bold text-gray-900 mb-8">
              Terms of Service
            </h1>
            <div className="text-gray-600 space-y-6 leading-relaxed">
              <div className="space-y-4">
                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  1. Acceptance of Terms
                </h2>
                <p>
                  By accessing and using the services of Trusted Trademark Filer, you accept and agree to be bound by the terms and conditions of this agreement. If you do not agree to these terms, please do not use our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  2. Services Description
                </h2>
                <p>
                  Trusted Trademark Filer provides trademark registration, intellectual property protection, and related legal services. We assist clients in filing trademark applications, conducting searches, and managing their intellectual property portfolio.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  3. User Responsibilities
                </h2>
                <p>
                  You agree to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide accurate and complete information</li>
                  <li>Maintain the confidentiality of your account information</li>
                  <li>Notify us immediately of any unauthorized use</li>
                  <li>Use our services only for lawful purposes</li>
                  <li>Pay all applicable fees in a timely manner</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  4. Fees and Payment
                </h2>
                <p>
                  Service fees are as outlined in our pricing plans. Government filing fees are separate and payable directly to the USPTO. All fees are non-refundable except as required by law or as explicitly stated in our refund policy.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  5. No Guarantee of Approval
                </h2>
                <p>
                  While we strive for the highest approval rates, we cannot guarantee that your trademark application will be approved by the USPTO. Approval is subject to USPTO examination and applicable trademark laws.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  6. Intellectual Property
                </h2>
                <p>
                  All content on our website, including text, graphics, logos, and software, is the property of Trusted Trademark Filer and is protected by intellectual property laws.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  7. Limitation of Liability
                </h2>
                <p>
                  To the maximum extent permitted by law, Trusted Trademark Filer shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  8. Attorney-Client Relationship
                </h2>
                <p>
                  Use of our services does not create an attorney-client relationship unless explicitly agreed upon in writing. For legal representation services, separate engagement agreements apply.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  9. Termination
                </h2>
                <p>
                  We reserve the right to terminate or suspend your access to our services at any time, without notice, for conduct that we believe violates these Terms of Service or is harmful to other users.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  10. Governing Law
                </h2>
                <p>
                  These Terms of Service shall be governed by and construed in accordance with the laws of the United States and the State of California, without regard to conflict of law provisions.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  11. Changes to Terms
                </h2>
                <p>
                  We reserve the right to modify these terms at any time. We will notify users of any material changes by posting the updated terms on our website.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8">
                  12. Contact Information
                </h2>
                <p>
                  If you have questions about these Terms of Service, please contact us at:
                </p>
                <p className="font-semibold">
                  Email: Info@trustedtrademarkfiler.com<br />
                  Phone: +1 (888) 203 1471<br />
                  Address: 28202 Cabot Rd #300, Laguna Niguel, CA 92677, United States
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsOfServicePage;